import { UseGqlMutationCallbacks } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { CreateLoginCodeMutation, useCreateLoginCodeMutation } from './createLoginCode_gen'

type CreateLoginCodeProps = { tel: string }

type UseCreateLoginCodeMutationOptions = UseGqlMutationCallbacks<
  CreateLoginCodeMutation,
  CreateLoginCodeProps
>

export const useCreateLoginCode = (mutationOptions?: UseCreateLoginCodeMutationOptions) => {
  const intl = useIntl()

  const _mutationOptions = useMutationNotifier(
    {
      onMutate: intl.formatMessage({ id: 'auth.login.requesting_code' }),
      onSuccess: false,
    },
    mutationOptions
  )

  const { mutateAsync: createLoginCode } = useCreateLoginCodeMutation()
  return useMutation(['createLoginCode'], (input) => createLoginCode({ input }), _mutationOptions)
}
